<template>
  <div>
    <p v-html="sanitizedTitle" class="mt-0 h5" data-testid="summary-title"></p>
    <p
      v-if="sanitizedSubtitle"
      v-html="sanitizedSubtitle"
      data-testid="summary-subtitle"
      data-private
    ></p>
    <div>
      <template v-if="trend !== 0">
        <v-icon v-if="trend > 0" class="up" data-testid="summary-trend-icon">
          mdi-chevron-up</v-icon
        >
        <v-icon v-else class="down" data-testid="summary-trend-icon">
          mdi-chevron-down</v-icon
        >
      </template>
      <span
        v-html="sanitizedContent"
        data-testid="summary-content"
        class="body1 ms-1"
        data-private
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Summary',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    sanitizedTitle() {
      const title = this.data?.title ?? ''
      return this.$sanitize(title)
    },

    sanitizedSubtitle() {
      const subtitle = this.data?.subtitle ?? ''
      return this.$sanitize(subtitle)
    },

    sanitizedContent() {
      const content = this.data?.content ?? ''
      return this.$sanitize(content)
    },

    trend() {
      return this.data?.trend ?? 0
    },
  },
}
</script>

<style lang="scss" scoped>
.up {
  will-change: transform;
  color: $color-green;
  font-size: 24px;
}

.down {
  will-change: transform;
  color: $color-red;
  margin-top: -5px;
  font-size: 24px;
}
</style>
